
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { isTokenExpired } from "../helpers/isTokenExpired";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom"; // ← Add this at top

const AppContext = React.createContext();

const AppProvider = ({ children }) => {

  const location = useLocation(); // ← Inside component

  const [loadingApp, setLoadingApp] = useState(true);
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [SiteConfig, setSiteConfig] = useState({
    CURRENT_USER_NAME: '',
    CURRENT_USER_EMAIL: '',
    CURRENT_USER_ID: '',
    CURRENT_USER_ROLE: '',
    CURRENT_USER_TYPE: '',
    CURRENT_USER_TENANT_ID: null,
    CURRENT_USER_TENANT_NAME: '',
    CURRENT_USER_TENANT_DISPLAY_NAME: '',
    CURRENT_USER_TENANT_EMAIL: '',
    CURRENT_USER_TENANT_ADDRESS: '',
    CURRENT_USER_TENANT_EXP: '',
    CURRENT_USER_PROFILEIMAGE: '',
    CURRENT_USER_CUSTOMER_ID: '',
    CURRENT_USER_CUSTOMER_NAME: '',
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    API_NOTIFICATION_HUB_URL: process.env.REACT_APP_API_NOTIFICATION_HUB_URL,
    API_AUTH_TOKEN: process.env.REACT_APP_API_AUTH_TOKEN,
  });

  const navigate = useNavigate();

  // Logout function
  const logout = () => {
    // Clear all storage
    localStorage.clear();
    
    // Clear all cookies (not just auth token)
    const cookies = Cookies.get();
    Object.keys(cookies).forEach(cookieName => {
      Cookies.remove(cookieName, { path: '/' });
    });
    
    // Reset all state
    setToken(null);
    setUser(null);
    setSiteConfig({
      CURRENT_USER_NAME: '',
      CURRENT_USER_EMAIL: '',
      CURRENT_USER_ID: '',
      CURRENT_USER_ROLE: '',
      CURRENT_USER_TYPE: '',
      CURRENT_USER_TENANT_ID: null,
      CURRENT_USER_TENANT_NAME: '',
      CURRENT_USER_TENANT_DISPLAY_NAME: '',
      CURRENT_USER_TENANT_EMAIL: '',
      CURRENT_USER_TENANT_ADDRESS: '',
      CURRENT_USER_TENANT_EXP: '',
      CURRENT_USER_PROFILEIMAGE: '',
      CURRENT_USER_CUSTOMER_ID: '',
      CURRENT_USER_CUSTOMER_NAME: '',
      API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
      API_NOTIFICATION_HUB_URL: process.env.REACT_APP_API_NOTIFICATION_HUB_URL,
      API_AUTH_TOKEN: process.env.REACT_APP_API_AUTH_TOKEN,
      CURRENT_TENANT_EARLY_CHECKOUT_ALLOWED: '',
    });
    
    // Navigate after a small delay to ensure cleanup is complete
    setTimeout(() => {
      navigate("/auths/auth-login", { replace: true });
    }, 100);
  };

  // On mount, try to rehydrate token from localStorage
  useEffect(() => {
    //const savedToken = localStorage.getItem(process.env.REACT_APP_API_AUTH_TOKEN);
    const savedToken = Cookies.get(process.env.REACT_APP_API_AUTH_TOKEN);
    if (savedToken) {
      setToken(savedToken);

      try {
        const decoded = jwt_decode(savedToken);
        const tokenExpired = isTokenExpired(decoded);

        if (tokenExpired) {
          logout(); // call logout instead of duplicating logic
        } else {
          setUser(decoded);

          const SiteConfigLocal = {
            CURRENT_USER_NAME: decoded.UserName,
            CURRENT_USER_EMAIL: decoded.UserEmail,
            CURRENT_USER_ID: decoded.UserId,
            CURRENT_USER_ROLE:
              decoded.UserRole === "1"
                ? "admin"
                : decoded.UserRole === "family"
                  ? "family"
                  : (decoded.UserRole || "user"),
            CURRENT_USER_TYPE: decoded.UserType || "",
            CURRENT_USER_TENANT_ID: decoded.TenantID,
            CURRENT_USER_TENANT_NAME: decoded.TenantName,
            CURRENT_USER_TENANT_DISPLAY_NAME: decoded.TenantDisplayName,
            CURRENT_USER_TENANT_EMAIL: decoded.TenantEmail,
            CURRENT_USER_TENANT_ADDRESS: decoded.TenantAddress,
            CURRENT_USER_TENANT_EXP: decoded.exp,
            CURRENT_USER_PROFILEIMAGE: decoded.ProfileImage || "/images/avatar/c.jpg",
            CURRENT_USER_CUSTOMER_ID: decoded.CustomerId || "",
            CURRENT_USER_CUSTOMER_NAME: decoded.CustomerName || "",
            API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
            API_NOTIFICATION_HUB_URL: process.env.REACT_APP_API_NOTIFICATION_HUB_URL,
            API_AUTH_TOKEN: process.env.REACT_APP_API_AUTH_TOKEN,
            CURRENT_TENANT_EARLY_CHECKOUT_ALLOWED: decoded.early_check_out_allowed,
          };
          setSiteConfig(SiteConfigLocal);
        }
      } catch (err) {
        logout();
      }
    }

    setLoadingApp(false);
  }, []);

  // Redirect to login if no token after loading
  // useEffect(() => {
  //   if (!loadingApp && !token) {
  //     navigate("/auths/auth-login", { replace: true });
  //   }
  // }, [loadingApp, token, navigate]);

  useEffect(() => {
  if (!loadingApp && !token) {
    const allowedUnauthRoutes = ["/auths/auth-reset", "/auths/family-login", "/auths/auth-login"];
    const currentPath = location.pathname.toLowerCase().replace(/\/$/, "");

    if (!allowedUnauthRoutes.includes(currentPath)) {
      // Use a safe, deferred navigation
      requestAnimationFrame(() => {
        try {
          navigate("/auths/auth-login", { replace: true });
        } catch (e) {
          // Navigation error
        }
      });
    }
  }
}, [loadingApp, token, location, navigate]);



  // Don't render children until rehydration is done
  if (loadingApp) return null;

  return (
    <AppContext.Provider
      value={{
        loadingApp,
        setLoadingApp,
        user,
        setUser,
        token,
        setToken,
        SiteConfig,
        setSiteConfig,
        logout, // Make logout available
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };



// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import jwt_decode from "jwt-decode";
// import { isTokenExpired } from "../helpers/isTokenExpired";

// const AppContext = React.createContext();

// //const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// //const API_NOTIFICATION_HUB_URL = process.env.REACT_APP_API_NOTIFICATION_HUB_URL;
// //const API_AUTH_TOKEN = process.env.REACT_APP_API_AUTH_TOKEN;

// const AppProvider = ({ children }) => {

 
//   const [loadingApp, setLoadingApp] = useState(true);
//   const [token, setToken] = useState(null);
//   const [user, setUser] = useState(null);  
//   const [SiteConfig, setSiteConfig] = useState({
//     CURRENT_USER_NAME : '',
//     CURRENT_USER_EMAIL : '',
//     CURRENT_USER_ID : '',
//     CURRENT_USER_ROLE : '',
//     CURRENT_USER_TENANT_ID : null,
//     CURRENT_USER_TENANT_NAME : '',
//     CURRENT_USER_TENANT_DISPLAY_NAME : '',
//     CURRENT_USER_TENANT_EMAIL : '',
//     CURRENT_USER_TENANT_ADDRESS : '',
//     CURRENT_USER_TENANT_EXP : '',
//     API_BASE_URL : process.env.REACT_APP_API_BASE_URL,
//     API_NOTIFICATION_HUB_URL : process.env.REACT_APP_API_NOTIFICATION_HUB_URL,
//     API_AUTH_TOKEN : process.env.REACT_APP_API_AUTH_TOKEN,
//   });

  
//   const navigate = useNavigate();

//   // On mount, try to rehydrate token from cookie/localStorage
//   useEffect(() => {

//     const savedToken = localStorage.getItem(process.env.REACT_APP_API_AUTH_TOKEN);
//     if (savedToken) {

//       setToken(savedToken);
      
//       const decoded = jwt_decode(savedToken);

//       const tokenExpired = isTokenExpired(decoded);

//       if (tokenExpired) {
//         console.log("Token has expired.");
//         setUser(null);
//         setToken(null);
//       } else {
//         console.log("Token is still valid.");
//         setUser(decoded);       

    

//         const SiteConfigLocal = {
//           CURRENT_USER_NAME : decoded.UserName,
//           CURRENT_USER_EMAIL : decoded.UserEmail,
//           CURRENT_USER_ID : decoded.UserId,
//           CURRENT_USER_ROLE : (decoded.UserRole === "1" ? "admin" : "user"),
//           CURRENT_USER_TENANT_ID : decoded.TenantID,
//           CURRENT_USER_TENANT_NAME : decoded.TenantName,
//           CURRENT_USER_TENANT_DISPLAY_NAME : decoded.TenantDisplayName,
//           CURRENT_USER_TENANT_EMAIL : decoded.TenantEmail,
//           CURRENT_USER_TENANT_ADDRESS :  decoded.TenantAddress,
//           CURRENT_USER_TENANT_EXP : decoded.exp,
//           API_BASE_URL : process.env.REACT_APP_API_BASE_URL,
//           API_NOTIFICATION_HUB_URL : process.env.REACT_APP_API_NOTIFICATION_HUB_URL,
//           API_AUTH_TOKEN: process.env.REACT_APP_API_AUTH_TOKEN,
//         }          
//         setSiteConfig(SiteConfigLocal);

//       }

//     }
//     setLoadingApp(false);
//   }, []);

//   // Whenever token changes, if it's null and we've finished loading, redirect
//   useEffect(() => {
//     if (!loadingApp && !token) {
//       navigate("/auths/auth-login", { replace: true });
//     }
//   }, [loadingApp, token, navigate]);

//   // While we're rehydrating, don't show anything
//   if (loadingApp) {
//     return null; // or a spinner
//   }

//   return (
//     <AppContext.Provider
//       value={{
//         loadingApp,
//         setLoadingApp,
//         user,
//         setUser,
//         token,
//         setToken,
//         SiteConfig, 
//         setSiteConfig,
//       }}
//     >
//       {children}
//     </AppContext.Provider>
//   );
// };

// export { AppContext, AppProvider };




// // import React, { useEffect, useState } from "react";

// // const AppContext = React.createContext();

// // const AppProvider = ({ children }) => {
// //   const [loadingApp, setLoadingApp] = useState(true);
// //   const [token, setToken] = useState(null);
// //   const [user, setUser] = useState(null);

// //   return (
// //     <AppContext.Provider
// //       value={{
// //         loadingApp,
// //         setLoadingApp,
// //         user,
// //         setUser,
// //         token,
// //         setToken,
// //       }}
// //     >
// //       {children}
// //     </AppContext.Provider>
// //   );
// // };

// // export { AppContext, AppProvider };
